import { render, staticRenderFns } from "./ImportFromMeta.vue?vue&type=template&id=5849941c&scoped=true&"
import script from "./ImportFromMeta.vue?vue&type=script&lang=js&"
export * from "./ImportFromMeta.vue?vue&type=script&lang=js&"
import style0 from "./ImportFromMeta.vue?vue&type=style&index=0&id=5849941c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5849941c",
  null
  
)

export default component.exports